import Splide from '@splidejs/splide';
import { URLHash } from '@splidejs/splide-extension-url-hash';
import '@splidejs/splide/css';

function initializeReelSplide() {
  const reelElement = document.querySelector('.js-videoReel');
  if (!reelElement) return;

  const reelSplide = new Splide(reelElement, {
    direction: 'ttb',
    perMove: 1,
    arrows: false,
    pagination: false,
    height: '100dvh',
    updateOnMove: true,
    flickMaxPages: 1,
  });

  reelSplide.on('inactive', (slide) => {
    const video = slide.slide.querySelector('video');
    if (video) video.pause();
  });

  reelSplide.on('active', (slide) => {
    const lastHref = window.location.href;

    const slideElement = slide.slide;
    const lastCategory = slideElement.getAttribute('data-movie-category');
    const lastNumber = slideElement.getAttribute('data-movie-number');
    const lastTitle = slideElement.getAttribute('data-movie-title');

    let hasThumbnail = slideElement.querySelector('.js-video').getAttribute('poster');
    let thumbnailSrc = '';
    if (hasThumbnail) {
      thumbnailSrc = hasThumbnail;
      hasThumbnail = 'true';
    } else {
      thumbnailSrc = '';
      hasThumbnail = 'false';
    }

    localStorage.setItem('lastHref', lastHref);
    localStorage.setItem('lastCategory', lastCategory);
    localStorage.setItem('lastNumber', lastNumber);
    localStorage.setItem('lastTitle', lastTitle);
    localStorage.setItem('hasThumbnail', hasThumbnail);
    localStorage.setItem('thumbnailSrc', thumbnailSrc);
  });

  reelSplide.mount({ URLHash });
}

function resumeLastVideo() {
  const videoHistoryArea = document.querySelector('.js-videoHistory');
  if (!videoHistoryArea) return;

  const lastHref = localStorage.getItem('lastHref');
  if (!lastHref) {
    videoHistoryArea.classList.add('is-hidden');
    return;
  }

  const lastCategory = localStorage.getItem('lastCategory');
  const lastNumber = localStorage.getItem('lastNumber');
  const lastTitle = localStorage.getItem('lastTitle');
  const hasThumbnail = localStorage.getItem('hasThumbnail');
  const thumbnailSrc = localStorage.getItem('thumbnailSrc');

  const videoHistoryLink = videoHistoryArea.querySelector('.js-videoHistoryLink');
  const videoHistoryCategory = videoHistoryArea.querySelector('.js-videoHistoryCategory');
  const videoHistoryNumber = videoHistoryArea.querySelector('.js-videoHistoryNumber');
  const videoHistoryTitle = videoHistoryArea.querySelector('.js-videoHistoryTitle');
  const videoHistoryThumbnail = videoHistoryArea.querySelector('.js-videoHistoryThumbnail');

  videoHistoryLink.href = lastHref;
  videoHistoryCategory.textContent = lastCategory;
  videoHistoryNumber.textContent = lastNumber;
  videoHistoryTitle.textContent = lastTitle;
  if (hasThumbnail === 'true') {
    videoHistoryThumbnail.innerHTML = `<img src="${thumbnailSrc}" alt="${lastTitle}">`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initializeReelSplide();
  resumeLastVideo();
});
